<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
    <div>
        <vx-card class="p-4 mb-6">
            <div class="flex flex-wrap items-center justify-between mb-10">
                <div class="flex items-center">
                    <h4 style="margin-left: 10px">FG Receiving</h4>
                </div>
                <div class="flex items-center">
                    <vs-button
                        @click="fetchData"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="refresh"
                    >Refresh</vs-button>
                    <vs-button
                        @click="searchInit"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="add"
                    >Add</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        icon="remove_red_eye"
                        @click="handleView"
                    >View</vs-button>
                    <!-- @click="showFilter = true"-->
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        icon="filter_list"
                        @click="filterInit"
                    >Filter</vs-button>
                    <vs-button
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="import_export"
                        @click="exportExel"
                    >Export</vs-button>
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="data"
                colResizeDefault="shift"
                rowSelection="single"
                @selection-changed="onSelectionChanged"
                @rowDoubleClicked="handleView"
                :animateRows="false"
                :floatingFilter="false"
            ></ag-grid-vue>
            <p class="text-right">
                <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
            </p>
            <vs-pagination
                :total="totalPage"
                v-model="currentPage"
                :max="7"
            ></vs-pagination>
        </vx-card>
        
        <vs-prompt
            :active.sync="search.show"
            title="Search Production"
            @accept="submit"
        >
            <div class="con-exemple-prompt">
                <div class="vx-col w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Reference*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="search.reference"/>
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col w-1/3">
                            Client*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-select
                                class="selectExample"
                                v-model="search.client_id"
                                width="100%"
                                autocomplete
                                @input-change="searchDropdown($event, client)"
                            >
                                <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                            </vs-select>
                        </div>
                    </div>
                </div>
                <vs-alert v-if="search.error" color="danger" vs-icon="new_releases" class="mt-5">
                    {{ search.error }}
                </vs-alert>
            </div>
        </vs-prompt>
        

        <!-- filter dialog -->
        <vs-prompt @accept="fetchData" title="Filter" :active.sync="showFilter">
            <div class="con-exemple-prompt">
                <vs-input v-model="filter.reference" class="mb-2 w-full" label="Reference" />

                <label class="vs-input--label">Client</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.client_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, client)"
                >
                    <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                </vs-select>
                <label class="vs-input--label">GR Date</label>
                <vs-row vs-w="12" vs-justify="space-between" class="mb-2">
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="5" style="padding-left: 0">
                        <flat-pickr class="vx-col w-full p-2" v-model="filter.gr_date_from" />
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="2">To</vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="5" style="padding-right: 0">
                        <flat-pickr class="vx-col w-full p-2" v-model="filter.gr_date_to" />
                    </vs-col>
                </vs-row>
            </div>
        </vs-prompt>
    </div>
</template>
<script>
import vSelect from "vue-select";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    components: {
        vSelect,
        AgGridVue,
        flatPickr
    },
    data() {
        return {
            search: {
                show: false,
                reference: '',
                client_id: null
            },
            isLoading: false,
            gridOptions: {},
            data: [],
            columnDefs: null,
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0,
            selectedId: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            client: {
                data: [],
                loading: false,
                endpoint: 'master/clients',
                objectKey: 'client_code'
            },
            filter: {
                fetchCount: 0,
                client_id: null,
                reference: '',
            },
            showFilter: false
        };
    },
    watch: {
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        }
    },
    methods: {
        onSelectionChanged() {
            var selectedRows = this.gridOptions.api.getSelectedRows()
            var selectedRowsString = ''
            selectedRows.forEach(function(selectedRow, index) {
                if (index !== 0) {
                selectedRowsString += ', '
                }
                selectedRowsString += selectedRow.id
            })
            this.selectedId = selectedRowsString
        },
        handleView() {
            this.$router.push({
                name: "fg-receiving-view",
                params: {
                    id: this.selectedId
                }
            });
        },
        fetchData() {
            this.data = [];
            this.isLoading = true
            Promise.all([
                this.$http.post("valueaddedservice/fgreceiving", this.filter)
            ])
                .then(
                    this.$http.spread(res => {
                        this.isLoading = false
                        this.data = res.data.data
                        this.totalPage = res.data.last_page;
                        this.dataFrom = res.data.from || 0;
                        this.dataTo = res.data.to || 0;
                        this.dataTotal = res.data.total;
                        this.showFilter = false;
                    })
                )
                .catch(err => console.log(err))
        },
        searchInit() {
            this.isLoading = true;
            this.$http.post('master/clients')
            .then(res => {
                this.client.data = res.data.data;
                this.search.show = true;
                this.isLoading = false;
            })
            .catch(error => this.handleError(error));
        },
        submit() {
            this.search.show = false;
            this.isLoading = true;

            this.$http.post('valueaddedservice/fgreceiving/search', {
                reference: this.search.reference,
                client_id: this.search.client_id
            })
            .then(res => {
                this.$router.push({
                    name: 'fg-receiving-add',
                    params: {
                        data: res.data
                    }
                });
            })
            .catch(error => {
                this.isLoading = false;
                this.search.error = error.response.data.message || 'Server Error'
                this.search.show = true;
            });
        },
        filterInit() {
            if(this.filter.fetchCount < 1) {
                this.isLoading = true
                this.fetchDropdowns()
                .then(() => {
                    this.isLoading = false
                    this.showFilter = true
                    this.filter.fetchCount++
                })
                .catch(() => {
                    this.isLoading = false
                    this.$vs.dialog({
                        type: "confirm",
                        color: "danger",
                        title: "Server Error",
                        text: "Try again?",
                        accept: () => {
                            this.filterInit();
                        },
                        acceptText: "Yes",
                        cancelText: "No"
                    });
                })
            }
            else {
                this.showFilter = true
            }
        },
        fetchDropdowns() {
            return Promise.all([
                this.$http.post("/master/clients"),
            ]).then(
                this.$http.spread((clients) => {
                    this.client.data = clients.data.data;
                    
                    this.client.data.unshift({
                        id: null,
                        client_code: 'Any'
                    })
                })
            );
        },
        exportExel() {
            this.isLoading = true;
            this.$http.post("valueaddedservice/fgreceiving/export", 
            this.filter, {
                responseType: "blob"
            })
            .then(response => {
                var blob = new Blob([response.data], {
                    type: "application/pdf"
                });
                this.isLoading = false;
                saveAs(blob, "fg_receiving.xlsx");
            });
        },
    },
    computed: {},
    mounted() {
        this.$http.post("unlock_all");
        this.fetchData();
    },
    beforeMount() {
        const filter = this.getFilter();

        if(filter) {
            this.filter = filter
            this.filter.fetchCount = 0;
        }

        if (this.isLoading) {
            this.$vs.loading();
        }

        this.columnDefs = [
            {
                headerName: "FGR ID",
                field: "id",
                width: 120
            },
            {
                headerName: "Reference",
                field: "reference",
                width: 120
            },
            {
                headerName: "Client ID",
                field: "vas.client.client_code",
                width: 120
            },
            {
                headerName: "Warehouse ID",
                field: "vas.warehouse.warehouses_code",
                width: 120
            },
            {
                headerName: "GR Date",
                field: "gr_date",
                width: 120
            },
            {
                headerName: "Production / Unpack Reference",
                field: "vas.reference",
                width: 120
            },
            {
                headerName: "FGR Status",
                field: "status.name",
                width: 120
            },
        ];
        this.gridOptions.getRowHeight = function(params) {
            return 35;
        }
    }
};
</script>